import axiosInstance from '../../config/axiosConfig';
import { urlContramedidas, urlVulnerabilidadContramedida } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

export async function getContramedidas() {
  try {
    const response = await axiosInstance.get(urlContramedidas);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching contramedidas:', error);
    throw error;
  }
}

// Alias para compatibilidad con código existente
export async function getContramedidasGenerales() {
  return getContramedidas();
}

export async function getContramedidasPorEmpresa(emp_codigo) {
  try {
    const response = await axiosInstance.get(`${urlContramedidas}/empresa/${emp_codigo}`);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching contramedidas by company:', error);
    throw error;
  }
}

export async function getContramedida(id) {
  try {
    const response = await axiosInstance.get(`${urlContramedidas}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching contramedida ${id}:`, error);
    throw error;
  }
}

export async function createContramedidas(formulario) {
  try {
    const response = await axiosInstance.post(urlContramedidas, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating contramedida:', error);
    throw error;
  }
}

export async function updateContramedidas(id, formulario) {
  try {
    const response = await axiosInstance.put(`${urlContramedidas}/${id}`, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating contramedida ${id}:`, error);
    throw error;
  }
}

export async function deleteContramedidas(id) {
  try {
    const response = await axiosInstance.delete(`${urlContramedidas}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting contramedida ${id}:`, error);
    throw error;
  }
}

export async function asociarContramedidasVulnerabilidades(asociaciones) {
  try {
    const responses = await Promise.all(
      asociaciones.map(({ con_codigo, vul_codigo }) =>
        axiosInstance.post(urlVulnerabilidadContramedida, { vul_codigo, con_codigo })
      )
    );
    return responses.map(res => res.data);
  } catch (error) {
    console.error('Error asociando contramedidas con vulnerabilidades:', error);
    throw error;
  }
}

export async function getContramedidasByVulnerabilidad(vul_codigo) {
  try {
    const response = await axiosInstance.get(`${urlVulnerabilidadContramedida}/vulnerabilidad/${vul_codigo}`);
    return extractArray(response);
  } catch (error) {
    console.error(`Error fetching contramedidas for vulnerabilidad ${vul_codigo}:`, error);
    throw error;
  }
}

export async function deleteVulnerabilidadContramedida(vul_codigo, con_codigo) {
  try {
    const response = await axiosInstance.delete(`${urlVulnerabilidadContramedida}/${vul_codigo}/${con_codigo}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting vulnerabilidad-contramedida relationship:`, error);
    throw error;
  }
}